query ProductsList(
  $page: Int
  $rowsPerPage: Int
  $search: String
  $countryAccessId: ID
  $dateFrom: DateTime
  $dateTo: DateTime
  $status: ProductStatus
  $types: [ProductType!]
) {
  products(
    page: $page
    rowsPerPage: $rowsPerPage
    search: $search
    countryAccessId: $countryAccessId
    dateFrom: $dateFrom
    dateTo: $dateTo
    status: $status
    types: $types
  ) {
    count
    nodes {
      id
      type
      title
      status
      publishAt
      startAt
      finishAt
      finishSalesAt
      showContent
      hideInGeneralLists
      perContentPurchase
      preview {
        id
        url(format: SMALL)
      }
      siteUrl
      prices {
        id
        currency
        period
        trialPeriod
        trialValue
        countryAccessId
        periods {
          id
          dateFrom
          value
          oldValue
        }
      }
      videosCount
      streamsCount
      collectionsCount
      createdAt
      updatedAt
    }
  }
}
